import type { AvailableSitesResponse } from '@atlassiansox/cross-flow-plugins';
import { sendErrorEvent } from '@trello/error-reporting';
import { TrelloStorage } from '@trello/storage';

import { getAvailableSitesStorageKey } from './getAvailableSitesStorageKey';

const DAY_IN_MS = 86_400_000;

export const getCachedAvailableSites: () =>
  | AvailableSitesResponse['sites']
  | null = () => {
  try {
    const TIMESTAMP_EXPIRATION_DURATION_IN_MS =
      DAY_IN_MS + Math.floor(Math.random() * 15_000_000);
    const availableSitesStorage = TrelloStorage.get(
      getAvailableSitesStorageKey(),
    );
    if (availableSitesStorage) {
      if (typeof availableSitesStorage.timestamp === 'number') {
        return availableSitesStorage.timestamp +
          TIMESTAMP_EXPIRATION_DURATION_IN_MS >=
          Date.now()
          ? availableSitesStorage?.data?.sites
          : null;
      } else {
        throw new Error('Unexpected localStorage timestamp type');
      }
    } else {
      return null;
    }
  } catch (error) {
    sendErrorEvent(error, {
      tags: {
        ownershipArea: 'trello-cross-flow-b',
        feature: 'Atlassian Switcher',
      },
    });
    return null;
  }
};
